import styled from 'styled-components';
import { BreakPoint, Color, Font, FontSize } from '../../asset/styles';

// Permission

export const StyledBox = styled.div`
  background-color: ${Color.white};
  border-top: solid 1px ${Color.border.darkRed};
  box-sizing: border-box;
  font-family: ${Font.default};
  padding: 16px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;

  @media (min-width: ${BreakPoint.desktop}) {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16);
    width: 456px;
    bottom: 32px;
    top: auto;
    left: auto;
    right: 10%;
  }

  * {
    font-family: ${Font.default};
  }
`;

export const StyledFlexBox = styled.div`
  display: flex;
`;

// const MessageBox = FlexBox.extend`
export const StyledMessageBox = styled(StyledFlexBox)`
  justify-content: flex-end;
`;

export const StyledMessage = styled.div`
  color: ${Color.text.black};
  font-size: ${FontSize.medium};
  word-break: break-all;

  @media (min-width: ${BreakPoint.desktop}) {
    flex: 1;
  }

  @media (max-width: ${BreakPoint.small}) {
    font-size: ${FontSize.smallDevice.medium};
  }
`;

// const Buttons = FlexBox.extend`
export const StyledButtons = styled(StyledFlexBox)`
  /*margin-top: 16px;*/
  padding-top: 16px;
`;

export const StyledLeftButton = styled.div`
  flex: 1;
  margin-right: 8px;
`;

export const StyledRightButton = styled.div`
  flex: 1;
  margin-left: 8px;
`;

export const StyledClose = styled.div`
  margin-left: 20px;
`;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/permission/style.js